import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

/**
 * Componente para proteger rotas que requerem autenticação
 * Conforme doc 06-guia-de-estilo-frontend.md
 */

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, isAdmin, loading, user } = useAuth();

  // Aguardar carregamento inicial
  if (loading) {
    return <div className="container">Carregando...</div>;
  }

  // Verificar autenticação
  if (!isAuthenticated || !user) {
    console.log('ProtectedRoute: Usuário não autenticado, redirecionando para login');
    return <Navigate to="/login" replace />;
  }

  // Verificar permissões de admin
  if (requireAdmin && !isAdmin) {
    return (
      <div className="container">
        <h2>Acesso Negado</h2>
        <p>Você não tem permissão para acessar esta página.</p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
